import { NgModule } from '@angular/core';

import { HisUiService, HisGenericValueService } from 'hisng';

import { StateService } from 'app/fs/res/common/service/core/state.service';
import { PersonService } from 'app/fs/res/common/service/person/person.service';
import { ProjectService } from 'app/fs/res/finance/service/project/project.service';
import { ResearchPartnerService } from 'app/fs/res/common/service/researchPartner/researchPartner.service';
import { OrganizationService } from 'app/fs/res/common/service/organization/organization.service';
import { BudgetSourceService } from 'app/fs/res/finance/service/budget-source/budget-source.service';

import { PatentService } from './service/patent/patent.service';
import { PatentSharedModule } from './patent-shared.module';
import { PatentRoutesModule } from './patent.routes';

/**
 * CoreModule for projects.
 */
@NgModule( {
    imports: [
        PatentSharedModule,
        PatentRoutesModule
    ],
    declarations: [
    ],
    exports: [
        PatentSharedModule
    ],
    providers: [
        /* common */
        HisUiService,
        HisGenericValueService,

        PersonService,
        BudgetSourceService,
        StateService,
        OrganizationService, // internal organizations
        ProjectService,

        PatentService,
        ResearchPartnerService
    ],
} )

export class PatentCoreModule {
}
